interface SectionTitleAndDescriptionProps {
  title: string;
  description: React.ReactNode;
}
export const SectionTitleAndDescription = ({
  title,
  description,
}: SectionTitleAndDescriptionProps) => {
  return (
    <div className="">
      <h2 className="mb-16 font-display text-32-40 font-bold text-gray-900 dark:text-white sm:mb-24">
        {title}
      </h2>
      <div className="max-w-md text-14-22 dark:text-gray-500 sm:text-18-28 sm:text-gray-800">
        {description}
      </div>
    </div>
  );
};
